// Every English string the prep-item and production screens show, in one place
// so an Urdu table can be added later without touching the components.
// Plain words, short sentences: the people using these screens work in a
// kitchen, not an office.

export const PREP_TEXT = {
  sectionTitle: 'Made in our kitchen',
  toggleLabel: 'This is a prep item (made in our kitchen)',
  toggleHelp: 'Turn this on for things you cook and keep, like a gravy, a marinade or a dough.',
  batchMakes: 'One batch makes',
  ingredientsTitle: 'What goes into one batch',
  addIngredient: 'Add ingredient',
  noIngredients: 'No ingredients yet. Add what one batch uses.',
  removeIngredient: 'Remove ingredient',
  qtyLabel: 'How much',
  unitLabel: 'Unit',
  save: 'Save recipe',
  saving: 'Saving…',
  undo: 'Undo changes',
  saved: 'Recipe saved',
  turnedOff: 'No longer made in the kitchen',
  costPerUnit: (unit: string) => `Cost per ${unit}`,
  costPerBatch: 'Cost of one batch',
  uncosted: (n: number) =>
    n === 1 ? '1 ingredient has no cost yet, so this cost is too low.' : `${n} ingredients have no cost yet, so this cost is too low.`,
  usedInTitle: 'Also used to make',
  madeInKitchen: 'made here',

  // problems found before saving
  pickIngredient: 'Pick an ingredient.',
  qtyAboveZero: 'Type how much (more than 0).',
  unitDoesNotFit: (name: string, unit: string) => `${name} is kept in ${unit}. Pick a unit that turns into ${unit}.`,
  notItself: 'An item cannot be an ingredient of itself.',
  sameTwice: (name: string) => `${name} is on the list twice. Put it on one line.`,
  yieldAboveZero: 'Type how much one batch makes (more than 0).',
  yieldUnitDoesNotFit: (unit: string) => `This item is kept in ${unit}. Pick a unit that turns into ${unit}.`,
  needOneIngredient: 'Add at least one ingredient.',

  // production
  productionTitle: 'Make a batch',
  howMuchToMake: 'How much to make',
  willUse: 'This will use from the kitchen:',
  startBatch: 'Start making',
  starting: 'Starting…',
  openBatches: 'Being made now',
  noOpenBatches: 'Nothing is being made right now.',
  finish: 'Finished',
  finishing: 'Saving…',
  howMuchMade: 'How much did you make?',
  expiryLabel: 'Use by (optional)',
  expiryRequiredLabel: 'Use by',
  cancelBatch: 'Cancel batch',
  cancelled: 'Batch cancelled',
  // Batch 2: cancelling asks first; a batch says which event it is for.
  cancelBatchConfirm: 'Cancel this batch? Nothing has been taken from the kitchen yet.',
  cancelBatchYes: 'Yes, cancel it',
  keepBatch: 'Keep it',
  forPlan: (what: string) => `For ${what}`,
  dismiss: 'OK',
  batchStarted: (no: string) => `Batch ${no} started`,
  batchFinished: (no: string) => `Batch ${no} finished`,
  shortTitle: 'The kitchen did not have enough of:',
  shortLine: (name: string, needed: string, had: string) => `${name}: needed ${needed}, had ${had}`,
  shortHelp: 'The batch is saved. Count these items or ask the store for more.',
  recentBatches: 'Last batches',
  planned: 'Planned',
  made: 'Made',
  statusPlanned: 'Waiting',
  statusInProgress: 'Cooking',
  statusDone: 'Done',
  statusCancelled: 'Cancelled',
  varianceExact: 'exactly as planned',
  varianceMore: (q: string) => `${q} more than planned`,
  varianceLess: (q: string) => `${q} less than planned`,
  saveRecipeFirst: 'Save the recipe first, then you can make a batch.',
  // kitchen manager's Production page
  makeTab: 'Make food',
  whatToMake: 'What are you making?',
  nothingToMake: 'Nothing is set up to be made here yet. Ask the store to add a recipe to the item.',
  onShelf: (q: string) => `On the kitchen shelf: ${q}`,
  oneBatch: (q: string) => `One batch makes ${q}`,
  batchCost: (amt: string) => `and costs about ${amt}`,
  queuedOffline: 'No connection — saved on this tablet. It will be sent by itself.',
  zeroYieldConfirm: 'You typed 0. That means the whole batch was lost. Tap Finished again to confirm.',
} as const
